// import http from './../../../base/api/public'
// let service = require('@/../config/serviceList')
// let sysConfig = require('@/../config/sysConfig')
// let apiPre = sysConfig.apiPre
// service.res = ''
// export default {
//   getCards (params) {
//     console.log('params:' + JSON.stringify(params))
//     return http.requestPost(apiPre + service.res + '/card/getList', params)
//   }
// }
// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {
  getStationVisualGroupOperatorId(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestQuickGet(apiPre + service.res + '/res/dataView/getStationVisualGroupOperatorId'+'?operatorId='+params)
  },
  getStationVisualGroupAddress(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestQuickGet(apiPre + service.res + '/res/dataView/getStationVisualGroupAddress'+'?operatorId='+params)
  },
  getStationVisualChargeAddress(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestQuickGet(apiPre + service.res + '/res/station/getStationVisualChargeAddress'+'?operatorId='+params)
  },
  getChargeAnalyseData (params) {
    return http.requestPost(apiPre + service.order + '/order/statistic/businessCenterStatistic', params)
  },
  getAnalyseData (params) {
    return http.requestPost(apiPre + service.member + '/member/customerFlow/customerFlowStatistics', params)
  },
  getStationOrder(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestQuickGet(apiPre + service.order + '/order/screen/stationOrder/' + params)
  },
  getGunRealTimeStatistics(params){
    console.log('params:' + params);
    return http.requestPost(apiPre + service.res + '/res/screen/gunRealTimeStatistics', params)
  },
  getOrderStatisticsV2(params){
    console.log('params:' + params);
    return http.requestPost(apiPre + service.order + '/order/screen/order_statistics_v2', params)
  },
  getOperatorStationRanking(params){
    console.log('params:' + params);
    return http.requestPost(apiPre + service.order + '/order/screen/operatorStationRanking', params)
  },
  getOrderStatistics(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestQuickGet(apiPre + service.order + '/order/screen/orderStatistics')
  },
  getRingStatistics(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestQuickGet(apiPre + service.order + '/order/screen/operatorOrderStatistics/' + params)
  },
}



// WEBPACK FOOTER //
// ./src/module/monitoringCenter/api/dataVisualApi.js